import {
  IWarehouseLocation,
  IWarehouseLocationCreate,
  IWarehouseLocationUpdate,
} from '../../../../../../modules/API/Warehouse/models/locations'
import { DEFAULT_LOCATION_TYPE, toLocationType } from '../../../../../../generic/artcoded/locationType'

const toTrimmedString = (value: unknown): string => String(value ?? '').trim()

const toNumericId = (value: unknown): number => {
  const parsed = Number(value)
  return Number.isFinite(parsed) ? parsed : 0
}

/** Normalizes form values into the POST body: trimmed strings, numeric WarehouseID/Room/LocationType, no Active/RecID. */
export const buildLocationCreatePayload = (
  values: Partial<IWarehouseLocation>,
): IWarehouseLocationCreate => ({
  CodeLocation: toTrimmedString(values.CodeLocation),
  WarehouseID: toNumericId(values.WarehouseID),
  Room: toNumericId(values.Room),
  Line: toTrimmedString(values.Line),
  LocationType: toLocationType(values.LocationType) ?? DEFAULT_LOCATION_TYPE,
})

/** Normalizes form values into the PUT body: create fields + RecID + boolean Active. */
export const buildLocationUpdatePayload = (
  recId: number,
  values: Partial<IWarehouseLocation>,
): IWarehouseLocationUpdate => ({
  RecID: recId,
  ...buildLocationCreatePayload(values),
  Active: Boolean(values.Active),
})
